import { useGetClientByIdQuery, useGetConsultationsQuery } from '@entities/clients/rtk-query.ts';
import { useConsultations } from '@entities/consultations';
import { useEffect, useState } from 'react';

export const useLoadConsultations = (id: number) => {
  const [page, setPage] = useState(1);
  const { addConsultations } = useConsultations();

  const { data: client, isLoading: isClientLoading } = useGetClientByIdQuery(id);

  const { data: consultationsData, isLoading: isConsultationsLoading } = useGetConsultationsQuery(
    {
      user: client?.user.id as number,
      page: page,
    },
    { skip: isClientLoading || !client }
  );

  useEffect(() => {
    if (consultationsData) {
      addConsultations(consultationsData.results);
    }
  }, [consultationsData, addConsultations]);

  return {
    loading: isClientLoading || isConsultationsLoading,
    consultations: consultationsData?.results || [],
    hasNextPage: Boolean(consultationsData?.next),
    loadMore: () => setPage(page + 1),
  };
};
